module.exports = __webpack_public_path__ + "img/bi.d03784fb.png";